import React, { useState, useEffect, useRef } from "react";

import HeaderComp from "./HeaderComp";
import SideBarComp from "./SideBarComp";

import {
  Divider,
  Input,
  Button,
  Icon,
  Menu,
  Table,
  Checkbox,
  Grid,
  Header,
  Radio,
  Image,
  Segment,
  Sidebar,
  Form,
} from "semantic-ui-react";
import { Route, Routes, Outlet } from "react-router-dom";
import {
  CreateCompany,
  ListCompany,
  ListUser,
  AddExpense,
  ListExpanse,
  NewInvoice,
  SpendMoney,
  ReciveMoney,
  ListInvoice,
  ListRecivedMoney,
  ListSpendMoney,
  DailyWorkList,
  CreateNewWork,
} from "../pages";
import FooterComp from "./FooterComp";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BaseUrl, BaseUrlInvoice } from "../pages/formcomponents/Constants";
import Cookies from "js-cookie";

const ContainerComp = () => {
  const [visible, setVisible] = React.useState(false);
  const navigate = useNavigate();
  const [paymentNotification, setpaymentNotification] = useState([]);
  const [documentExpiry, setdocumentExpiry] = useState([]);
  const [tableType, settableType] = useState(0);
  const [radioValue, setradioValue] = useState();
  const idleTimerRef = useRef(null);
  const IDLE_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes
  useEffect(() => {
    getExpiryPaymentList();
    startIdleTimer();
    const activityEvents = [
      "mousemove",
      "keydown",
      "click",
      "scroll",
      "touchstart",
    ];
    const resetTimer = () => startIdleTimer();
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetTimer, { passive: true })
    );
    const handleBeforeUnload = () => {
      Cookies.remove("authTokens");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      clearIdleTimer();
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const clearIdleTimer = () => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
      idleTimerRef.current = null;
    }
  };

  const startIdleTimer = () => {
    clearIdleTimer();
    idleTimerRef.current = setTimeout(() => {
      Cookies.remove("authTokens");
      navigate("/login");
    }, IDLE_TIMEOUT_MS);
  };
  const getExpiryPaymentList = () => {
    settableType(1);
    axios
      .post(BaseUrlInvoice + "accounts/listPurchaseNearingPayment", {
        id: 1,
      })
      .then((res) => {
        console.log("Notification", res.data);
        setpaymentNotification(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getExpiryDocList = (val) => {
    setVisible(true);
    settableType(2);
    setradioValue(val);
    //accounts/listExpiringDocuments

    axios
      .post(BaseUrlInvoice + "accounts/listExpiringDocuments", {
        nofDaysToExpiry: val,
      })
      .then((res) => {
        //setRecordForTable(res.data);
        setdocumentExpiry(res.data);
        console.log("Expiry Doc", res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div className="app-shell">
      <HeaderComp />
      <Sidebar.Pushable as={Segment} className="drawer-segment">
        <Sidebar
          as={Menu}
          animation="overlay"
          direction="right"
          inverted
          vertical
          visible={visible}
          className="drawer-panel"
        >
          <Menu.Item as="a" header className="drawer-header">
            <div></div>
            <div className="drawer-close" onClick={() => setVisible(false)}>
              X
            </div>
          </Menu.Item>
          <div className="drawer-body">
            {tableType == 1 && (
              <Table celled fixed singleLine className="notification-table">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Company</Table.HeaderCell>
                    <Table.HeaderCell>Amount</Table.HeaderCell>
                    <Table.HeaderCell>Payment Date</Table.HeaderCell>
                    <Table.HeaderCell>View</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {paymentNotification ? (
                    paymentNotification.map((item, index) => (
                      <Table.Row key={index}>
                        <Table.Cell>{item.buyerCompany}</Table.Cell>
                        <Table.Cell>{item.payment}</Table.Cell>
                        <Table.Cell>{item.chequePaymentDate}</Table.Cell>
                        <Table.Cell>
                          <Button
                            primary
                            onClick={() =>
                              navigate(
                                `/create-purchase/${item.purchaseId}/${item.categoryId}`
                              )
                            }
                          >
                            View
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))
                  ) : (
                    <Table.Row>
                      <Table.Cell>No Record Found</Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              </Table>
            )}
            {tableType == 2 && (
              <>
                <Grid.Row>
                  <Grid columns="five">
                    <Grid.Row>
                      <Form.Group>
                        <div className="radio-stack">
                          <Form.Field>
                            <Radio
                              label="5 days"
                              name="radioGroup"
                              value="1"
                              checked={radioValue === "1"}
                              onChange={() => getExpiryDocList("1")}
                            />
                          </Form.Field>
                          <Form.Field>
                            <Radio
                              label="15 Days"
                              name="radioGroup"
                              value="2"
                              checked={radioValue === "2"}
                              onChange={() => getExpiryDocList("2")}
                            />
                          </Form.Field>
                          <Form.Field>
                            <Radio
                              label="30 days"
                              name="radioGroup"
                              value="3"
                              checked={radioValue === "3"}
                              onChange={() => getExpiryDocList("3")}
                            />
                          </Form.Field>
                          <Form.Field>
                            <Radio
                              label="Already Expired"
                              name="radioGroup"
                              value="0"
                              checked={radioValue === "0"}
                              onChange={() => getExpiryDocList("0")}
                            />
                          </Form.Field>
                        </div>
                      </Form.Group>
                    </Grid.Row>
                  </Grid>
                </Grid.Row>

                <Table celled fixed singleLine className="notification-table">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Name</Table.HeaderCell>
                      <Table.HeaderCell>Exp Date</Table.HeaderCell>
                      <Table.HeaderCell>File Type</Table.HeaderCell>
                      <Table.HeaderCell>Days Remaining</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {documentExpiry ? (
                      documentExpiry.map((item, index) => (
                        <Table.Row key={index}>
                          <Table.Cell>{item.companyName}</Table.Cell>
                          <Table.Cell>{item.fileExpiry}</Table.Cell>
                          <Table.Cell>{item.fileType}</Table.Cell>
                          <Table.Cell>{item.nofDaysToExpiry}</Table.Cell>
                        </Table.Row>
                      ))
                    ) : (
                      <Table.Row>
                        <Table.Cell>No Record Found</Table.Cell>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>
              </>
            )}
          </div>
        </Sidebar>
        <Sidebar.Pusher>
          <Grid padded className="main-grid">
            <SideBarComp />
            <Grid.Column
              mobile={16}
              tablet={13}
              computer={13}
              floated="right"
              id="content"
              className="content-area"
            >
              <div className="content-surface">
                <Outlet />
              </div>
            </Grid.Column>
          </Grid>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
      <Grid padded className="tablet computer only bottom-alerts">
        <Menu fluid fixed="bottom" className="footer-menu">
          <Menu.Menu position="right">
            <Menu.Item
              onClick={() => {
                getExpiryPaymentList();
                setVisible(true);
              }}
            >
              <div className="footer-chip">
                Payment Notification ({paymentNotification.length})
              </div>
            </Menu.Item>
            <Menu.Item onClick={() => getExpiryDocList()}>
              <div className="footer-chip secondary">Expiry Document</div>
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      </Grid>
    </div>
  );
};

export default ContainerComp;
